import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import PageHeader from "../../components/PageHeader";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Paperclip, Loader2 } from "lucide-react";
import { toast } from "sonner";

const LIVELLI = [
  { v: "none", l: "Nessuna compressione" },
  { v: "bassa", l: "Bassa (90%)" },
  { v: "media", l: "Media (80%)" },
  { v: "alta", l: "Alta (60%)" },
];

export default function ImpostazioniAllegati() {
  const [val, setVal] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/allegati-settings").then(({ data }) => setVal(data.compressione)).catch((e) => toast.error(formatApiError(e.response?.data?.detail))); }, []);

  const save = async (v) => {
    setBusy(true);
    try { const { data } = await api.put("/admin/allegati-settings", { compressione: v }); setVal(data.compressione); toast.success("Livello di compressione salvato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (val === null) return <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>;
  return (
    <div data-testid="admin-impostazioni-allegati">
      <PageHeader title="Impostazioni allegati" subtitle="Impostazioni valide per tutti gli studi della piattaforma." icon={Paperclip} />
      <div className="max-w-2xl rounded-xl border border-slate-800 bg-[#121824] p-6 flex items-center justify-between gap-4">
        <div>
          <div className="text-sm font-semibold text-slate-100">Compressione immagini caricate</div>
          <div className="text-xs text-slate-400">Applicata a ogni nuova immagine JPEG/WebP caricata in tutti gli studi. I video e gli altri formati non vengono compressi.</div>
        </div>
        <Select value={val} onValueChange={save} disabled={busy}>
          <SelectTrigger className="w-56 shrink-0 bg-white border-slate-300 text-slate-900 font-medium" data-testid="allegati-compressione-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {LIVELLI.map((o) => <SelectItem key={o.v} value={o.v} data-testid={`allegati-compressione-${o.v}`}>{o.l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
